import { http, http2 } from "../conf/AxiosConfig.js";
import AppConfig from "@/conf/global.js";
import ProcessButton from "@/model/ProcessButton.js";

class FiltersDataService {
   getInfo(secondary) {
      //console.log("getInfo " + secondary);
      if (secondary == null || !secondary) return http.get("info");
      else return http2.get("info");
   }

   async getProcesosElectorales(secondary, idProceso, idProcesoElectoral) {
      //console.log("getProcesosElectorales secondary" + secondary);
      if (secondary == null || !secondary)
         return await http.get(AppConfig.procesosElectoralesFiltro.concat(idProceso).concat("/").concat(idProcesoElectoral));
      else return await http2.get(AppConfig.procesosElectoralesFiltro.concat(idProceso).concat("/").concat(idProcesoElectoral));
   }

   async getAmbitos(secondary, idProceso, idProcesoElectoral, idProcesoGeneral) {
      let uri = AppConfig.ambitosFiltro
         .concat(idProceso)
         .concat("/")
         .concat(idProcesoElectoral)
         .concat("/")
         .concat(idProcesoGeneral)
         .concat("/")
         .concat(AppConfig.ambitoTipoConf);
      if (secondary == null || !secondary) return await http.get(uri);
      else return await http2.get(uri);
   }

   async getEntidades(secondary, idProceso, idProcesoElectoral, idProcesoGeneral, ambito) {
      let uri = AppConfig.entidadesFiltro
         .concat(idProceso)
         .concat("/")
         .concat(idProcesoElectoral)
         .concat("/")
         .concat(idProcesoGeneral)
         .concat("/")
         .concat(ambito);
      if (secondary == null || !secondary) return await http.get(uri);
      else return await http2.get(uri);
   }

 
   async getActoresPoliticos(secondary, idProceso, idProcesoElectoral, idProcesoGeneral, ambito, idEstado) {
      let uri = AppConfig.actoresFiltro
         .concat(idProceso)
         .concat("/")
         .concat(idProcesoElectoral)
         .concat("/")
         .concat(idProcesoGeneral)
         .concat("/")
         .concat(ambito)
         .concat("/")
         .concat(idEstado);
      if (secondary == null || !secondary) return await http.get(uri);
      else return await http2.get(uri);
   }
   
   async getCargos(secondary, filtersSecundarios) {
      if (secondary == null || !secondary) return http.post(AppConfig.cargosFiltro, filtersSecundarios);
      else return http2.post(AppConfig.cargosFiltro, filtersSecundarios);
   }

   async getMunicipios(secondary, filtersSecundarios) {
      if (secondary == null || !secondary) return http.post(AppConfig.municipiosFiltro, filtersSecundarios);
      else return http2.post(AppConfig.municipiosFiltro, filtersSecundarios);
   }

   async getDistritos(secondary, filtersSecundarios) {
      if (secondary == null || !secondary) return http.post(AppConfig.distritosFiltro, filtersSecundarios);
      else return http2.post(AppConfig.distritosFiltro, filtersSecundarios);
   }

   setFilters(
      parIdProceso,
      parIdProcesoElectoral,
      parIdProcesoGeneral,
      parAmbito,
      parIdEstadoEleccion,
      parIdMunicipioEleccion,
      parIndexFirstElement,
      parPageMaxSize,
      parOrderField,
      parOrderType,
      parNombre,
      parPrimerApellido,
      parSegundoApellido,
      parIdSujetoObligado,
      parIdTipoCandidatura,
      parIdDistrito,
      parIdContabilidad
   ) {
      //console.log("parIdContabilidad: " + parIdContabilidad);
      let sortType = "ASC";
      if (parOrderType != "ASC" && parOrderType != 1) {
         sortType = "DESC";
      }
      const filters = {
         idProceso: parIdProceso,
         idProcesoElectoral: parIdProcesoElectoral,
         idProcesoGeneral: parIdProcesoGeneral,
         ambito: parAmbito,
         idEstadoEleccion: parIdEstadoEleccion,
         idMunicipioEleccion: parIdMunicipioEleccion,
         indexFirstElement: parIndexFirstElement,
         pageMaxSize: parPageMaxSize,
         orderField: parOrderField,
         orderType: sortType,
         nombre: parNombre,
         primerApellido: parPrimerApellido,
         segundoApellido: parSegundoApellido,
         idSujetoObligado: parIdSujetoObligado,
         idTipoCandidatura: parIdTipoCandidatura,
         idDistritoEleccion: parIdDistrito,
         idContabilidad: parIdContabilidad,
      };
      //console.log(filters);
      return filters;
   }

   setFiltersSecundarios(
      parIdProceso,
      parIdProcesoElectoral,
      parIdProcesoGeneral,
      parAmbito,
      parIdEstadoEleccion,
      parIdMunicipioEleccion,
      parIdSujetoObligado,
      parIdTipoCandidatura,
      parIdDistrito,
      parIdContabilidad
   ) {
      
      const filtersSecundarios = {
         idProceso: parIdProceso,
         idProcesoElectoral: parIdProcesoElectoral,
         idProcesoGeneral: parIdProcesoGeneral,
         ambito: parAmbito,
         idEstadoEleccion: parIdEstadoEleccion,
         idMunicipioEleccion: parIdMunicipioEleccion,
         idSujetoObligado: parIdSujetoObligado,
         idTipoCandidatura: parIdTipoCandidatura,
         idDistritoEleccion: parIdDistrito,
         idContabilidad: parIdContabilidad,
      };
      //console.log(filters);
      return filtersSecundarios;
   }
   

   getContabilidades(secondary, filters) {
      if (secondary == null || !secondary) return http.post(AppConfig.contabilidadesList, filters);
      else return http2.post(AppConfig.contabilidadesList, filters);
   }

   getContabilidades2(secondary, filters) {
      if (secondary == null || !secondary) return http.get(AppConfig.contabilidadesList, { params: { filters } });
      else return http2.get(AppConfig.contabilidadesList, { params: { filters } });
   }

   getContabilidadesConteo(secondary, filters) {
      if (secondary == null || !secondary) return http.post(AppConfig.contabilidadesConteo, filters);
      else return http2.post(AppConfig.contabilidadesConteo, filters);
   }

   getContabilidadesConteo2(secondary, filters) {
      if (secondary == null || !secondary) return http.get(AppConfig.contabilidadesConteo, { params: { filters } });
      else return http2.get(AppConfig.contabilidadesConteo, { params: { filters } });
   }

   getDetalle(secondary, contabilidad, descripcion, idProcesoGeneral) {
      if (secondary == null || !secondary)
         return http.post(AppConfig.campanaDetalle.concat(descripcion).concat("/").concat(idProcesoGeneral), contabilidad);
      else return http2.post(AppConfig.campanaDetalle.concat(descripcion).concat("/").concat(idProcesoGeneral), contabilidad);
   }

   getBtnCampain() {
      return new ProcessButton(
         "inactive",
         3,
         require("@/assets/images/campania_icono_activo.svg"),
         require("@/assets/images/campania_icono_inactivo.svg"),
         require("@/assets/images/campania_icono_hover.svg")
      );
   }

   getBtnPrecampain() {
      return new ProcessButton(
         "inactive",
         2,
         require("@/assets/images/precampania_icono_activo.svg"),
         require("@/assets/images/precampania_icono_inactivo.svg"),
         require("@/assets/images/precampania_icono_hover.svg")
      );
   }

   getBtnOrdinary() {
      return new ProcessButton(
         "inactive",
         1,
         require("@/assets/images/ordinario_icono_activo.svg"),
         require("@/assets/images/ordinario_icono_inactivo.svg"),
         require("@/assets/images/ordinario_icono_hover.svg")
      );
   }
}

export default new FiltersDataService();
